import React, { useCallback, useState } from 'react';
import block from 'bem-cn';
import SVGInline from 'react-svg-inline';
import { NumericFormat } from 'react-number-format';

import passwordSVG from './img/password.svg';
import passwordOffSVG from './img/passwordOff.svg';

import './Input.scss';

const b = block('input');

const Input = ({
  value,
  name,
  callBack,
  placeholder = '',
  size = 'default',
  type = 'text',
  isRequired,
  withEye,
  onChange,
  validState = 1,
  color,
  withFormatting,
  isBonus = false,
  bonusPlaceholder,
  isPercentFormat = false,
  isMobile = false,
  inTable = false,
  isAllowed,
  ...props
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const isPassword = type === 'password' && withEye;
  const passwordClick = useCallback(
    () => setPasswordVisible(!passwordVisible && isPassword),
    [passwordVisible, isPassword],
  );
  const currentType = { [true]: 'text', [false]: 'password' };

  return !withEye ? (
    withFormatting ? (
      <NumericFormat
        type={isPassword ? currentType[passwordVisible] : type}
        name={name}
        value={value}
        placeholder={bonusPlaceholder ? bonusPlaceholder : placeholder || ''}
        onChange={callBack || onChange}
        className={b({
          sizable: size,
          type,
          'with-eye': withEye,
          color,
          validState,
          bonus: isBonus,
          'bonus-without-value': isBonus && !value,
          mobile: isMobile,
          inTable,
        })}
        required={isRequired}
        isAllowed={isAllowed}
        allowNegative={false}
        decimalSeparator={!isPercentFormat ? '.' : undefined}
        thousandSeparator={!isPercentFormat ? ' ' : undefined}
        decimalScale={isPercentFormat ? undefined : 2}
        fixedDecimalScale={true}
        suffix={isPercentFormat ? '%' : ''}
        {...props}
      />
    ) : (
      <input
        type={type}
        name={name}
        value={value}
        placeholder={placeholder || ''}
        onChange={callBack || onChange}
        className={b({ sizable: size, type, color, validState })}
        required={isRequired}
        {...props}
      />
    )
  ) : (
    <div className={b('wrapper')}>
      {isPassword && (
        <SVGInline
          svg={passwordVisible ? passwordSVG : passwordOffSVG}
          className={b('password').toString()}
          onClick={passwordClick}
        />
      )}
      {withFormatting ? (
        <NumericFormat
          type={isPassword ? currentType[passwordVisible] : type}
          name={name}
          value={value}
          placeholder={bonusPlaceholder ? bonusPlaceholder : placeholder || ''}
          onChange={callBack || onChange}
          className={b({
            sizable: size,
            type,
            'with-eye': withEye,
            color,
            validState,
            bonus: isBonus,
            'bonus-without-value': isBonus && !value,
            mobile: isMobile,
            inTable,
          })}
          required={isRequired}
          allowNegative={false}
          decimalSeparator={!isPercentFormat ? '.' : undefined}
          thousandSeparator={!isPercentFormat ? ' ' : undefined}
          decimalScale={isPercentFormat ? undefined : 2}
          suffix={isPercentFormat ? '%' : ''}
          fixedDecimalScale={!isPercentFormat}
          {...props}
        />
      ) : (
        <input
          type={isPassword ? currentType[passwordVisible] : type}
          name={name}
          value={value}
          placeholder={placeholder || ''}
          onChange={callBack || onChange}
          className={b({ sizable: size, type, 'with-eye': withEye, color, validState })}
          required={isRequired}
          {...props}
        />
      )}
    </div>
  );
};

export default Input;
